import styled from "styled-components";

import { ExternalLink, Link } from "ui/Link";
import { Alert } from "ui/alert";
import {
  isLinkedInPersonalProfile,
  LinkedInProfile,
} from "api/social-account-connect/linkedin";

import { GetConnectButtonState } from "../connect-button";
import { AccountList } from "../account-list";

interface LinkedinProfileListProps {
  className?: string;
  profiles: LinkedInProfile[];
  getConnectButtonState: GetConnectButtonState<LinkedInProfile>;

  onConnect(profile: LinkedInProfile): void;

  onReconnect(): void;
}

export function LinkedinProfileList({
  className,
  profiles,
  onConnect,
  onReconnect,
  getConnectButtonState,
}: LinkedinProfileListProps) {
  return (
    <Root className={className}>
      <p>
        You've already connected your LinkedIn account to Sked. Below are the
        available Company Pages that you are an administrator of or profile.
      </p>
      <Alert>
        If the Company Page or Profile you are looking for is not shown, ensure
        you are an administrator of the Company Page and then reconnect by{" "}
        <Link onClick={onReconnect}>clicking here</Link>.
      </Alert>
      <h4>Available Company Pages or Profile:</h4>
      {profiles.length > 0 && (
        <AccountList
          items={profiles}
          onConnect={onConnect}
          renderItemLabel={(profile) => (
            <>
              <ExternalLink href={getLinkedInProfileLink(profile)}>
                {profile.localizedName}
              </ExternalLink>
              {isLinkedInPersonalProfile(profile) ? " (Personal Profile)" : ""}
            </>
          )}
          getConnectButtonState={getConnectButtonState}
        />
      )}
      {profiles.length === 0 && (
        <Alert>No linkedin profiles were returned</Alert>
      )}
    </Root>
  );
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 8px;

  & > * {
    margin: 0;
  }
`;

function getLinkedInProfileLink(profile: LinkedInProfile) {
  if (isLinkedInPersonalProfile(profile)) {
    return `https://www.linkedin.com/in/${profile.linkedinVanityName}`;
  } else {
    return `https://www.linkedin.com/organization/${profile.id}`;
  }
}
